import { useContext } from 'react';
import { PageLayout } from '../../../layout';
import { AgxButton, Images } from '@urbanx/agx-ui-components';
import { Link } from 'react-router-dom';
import '../error.scss';
import { AuthContext } from '@urbanx/agx.auth.client';

const PageNotFound = () => {
  const { userAccount } = useContext(AuthContext);
  return (
    <PageLayout
      agentName={userAccount?.firstName || ''}
      primaryPageTitle=""
      isError={true}
      transparent={true}
    >
      <div className="errorContainer__error">
        <div style={{ width: 500 }} className="errorContainer__error">
          <div className="circle__error">
            <Images.Warning />
          </div>
          <p className="smallTextStyle_error">404 page not found</p>
          <p className="largeTextStyle__error">Hmm, the page you’re looking for doesn’t exist</p>
          <p className="smallTextStyle_error">
            The link you clicked might no longer exist, or you may have accidentally typed in the
            wrong URL.
          </p>
        </div>
        <AgxButton
          text="Return home"
          large
          primary
          renderLink={(props) => <Link to={'/'} {...props} />}
        />
      </div>
    </PageLayout>
  );
};

export default PageNotFound;
